/* eslint-disable global-require */

export default {
  homescapes: [
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/zht/preview-01.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/zht/preview-02.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/zht/preview-03.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/zht/preview-04.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/zht/preview-05.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/zht/preview-06.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/zht/preview-07.webp'),
    },
  ],
  township: [
    {
      type: 'image',
      link: require('@/assets/images/township/preview/zht/preview-01.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/township/preview/zht/preview-02.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/township/preview/zht/preview-03.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/township/preview/zht/preview-04.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/township/preview/zht/preview-05.webp'),
    },
  ],
};
